import {HTTP} from '../http-common';

export default {
    // Constantes
    //TIPO:1,
    // Funciones comunes
    checkVersionHeader: function (response) {
        var version = response.headers['x-service-version'];
        if (window.$vue.$store.state.icoev.serviceVersion != version) {
            window.$vue.$store.commit('icoev/setServiceVersion',version);
            console.log("Service version:"+version);
        }
    },
    getCommonHeaders()
    {
        var headers = {};

        headers = {
            'authorization': 'Bearer ' + window.localStorage.getItem("vue-token")
        };

        if (/MSIE|Trident/.test(window.navigator.userAgent))
        {
            headers['Pragma'] = 'no-cache';
            headers['Cache-Control'] = 'no-cache, no-store';
        }

        return { headers: headers };
    },
    genericGet(service,cbok, cberr)
    {
        HTTP
            .get(window.baseServiceUrl+service,
            this.getCommonHeaders())
            .then((response) => {
                this.checkVersionHeader(response);
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    genericPut (service,data,cbok, cberr)
    {
        HTTP
            .put(window.baseServiceUrl+service,
            data,this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    genericPost(service,data,cbok, cberr)
    {
        HTTP
            .post(window.baseServiceUrl+service,
            data,this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    genericDelete(service,cbok, cberr)
    {
        HTTP
            .delete(window.baseServiceUrl+service,
            this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },

    /////////////////////////////////////////////////////////////////
    //COMMON

    getSessionInformation (offset, size, search, sortBy, sortDesc, cbok, cberr)
    {
        this.genericGet('documents/all/' + offset + '/' + size + '?search=' + search + '&sortBy=' + sortBy + '&sortDesc=' + sortDesc, cbok, cberr);
    },
    getDocuments (offset, size, search, sortBy, sortDesc, cbok, cberr)
    {
        this.genericGet('documents/list/' + offset + '/' + size + '?search=' + search + '&sortBy=' + sortBy + '&sortDesc=' + sortDesc, cbok, cberr);
    },
		createDocument (cbok, cberr)
    {
        this.genericPost('documents/create', null, cbok, cberr);
    },
		editDocument (data, cbok, cberr)
    {
        this.genericPost('documents/edit', data, cbok, cberr);
    },
		deleteDocument (id, cbok, cberr)
    {
        this.genericDelete('documents/delete/' + id, cbok, cberr);
    },
    uploadDocument (formData, cbok, cberr)
    {
        HTTP.post(window.baseServiceUrl + 'documents/uploadFile', formData,
          {
            headers: {
							'authorization': 'Bearer ' + window.localStorage.getItem("vue-token"),
              'Content-Type': 'multipart/form-data',
            }
          }
				).then((response) => {
					cbok(response.data);
				}).catch(function (error) {
					cberr(error);
				});
    },
    downloadDocument (id, cbok, cberr)
    {
        HTTP.get(window.baseServiceUrl + 'documents/downloadFile/' + id,
          {
            responseType: 'blob',
						headers: {
							'authorization': 'Bearer ' + window.localStorage.getItem("vue-token")
						}
          }
				).then((response) => {
					cbok(response.data);

					var link = document.createElement('a');

					var fileName = response.headers['x-file-name'];
					var contentType = response.headers['content-type'];
					var blob = new Blob([response.data], {type: contentType});

					//Soporte IE
					if (window.navigator && window.navigator.msSaveOrOpenBlob) {
						window.navigator.msSaveOrOpenBlob(blob, fileName);
						return;
					}

					var url= window.URL.createObjectURL(blob);
					link.href = url;
					link.download = fileName;
					document.body.appendChild(link);
					link.click();

					setTimeout(function() {
						document.body.removeChild(link);
						window.URL.revokeObjectURL(url);
					}, 1000);
				}).catch(function (error) {
					cberr(error);
				});
    },
}
